import React, { useEffect, useState, Children, lazy, Component } from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface Category {
  title: string;
  image: string;
}
const ALL_CATEGORIES: Category[] = [{
  title: "*WHAT'S NEW*",
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2Fvers1.png'
}, {
  title: 'GIFT CERTIFICATES',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FGift.jpeg'
}, {
  title: 'Custom Orders',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FCustom-Orders.png300x300.png'
}, {
  title: 'Americana Switchplates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FAmericana.jpeg'
}, {
  title: 'Angels & Christian',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FAngels.jpeg'
}, {
  title: 'Bath & Outhouses',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FBath.jpeg'
}, {
  title: 'Beach, Coastal & Palm Trees',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FBeach.jpeg'
}, {
  title: 'Beautiful Scenery & Settings',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FBeautifulScenery.jpeg'
}, {
  title: 'Birds--All Kinds!',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FBirds.jpeg'
}, {
  title: 'Butterflies, Dragonflies & Bugs',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FBugs.jpeg'
}, {
  title: 'Cars and Motorcycles',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FCars.jpeg'
}, {
  title: 'Cat Switch Plates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FCats.jpeg'
}, {
  title: 'Chef Switchplates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FChef.jpeg'
}, {
  title: 'Christmas, Snowmen, Winter',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FChristmas.jpeg'
}, {
  title: 'Classic Art',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FClassicArt.jpeg'
}, {
  title: 'Coffee & Tea Switchplates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FCoffee%26Tea.jpeg'
}, {
  title: 'Contemporary Switchplates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FContemporary.jpeg'
}, {
  title: 'Farm House Switchplates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFarm.jpeg'
}, {
  title: 'Cowboys, Southwest and Native American',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FCowboysSouthwestandNative%20American.jpeg'
}, {
  title: 'Dog Switchplates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FDog.jpeg'
}, {
  title: 'Fairies, Unicorns, Dragons & Mermaids',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFairy.jpeg'
}, {
  title: 'Farm Animals, Barns & Tractors',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFarmAnimals.jpeg'
}, {
  title: 'Fashion, Beauty & Boudoir',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFashion.jpeg'
}, {
  title: 'Fire Fighter & Police',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFirefighter.jpeg'
}, {
  title: 'Fishing Switch Plate Covers',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFishing.jpeg'
}, {
  title: 'Five Gang Switchplates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFive%20Gang%20Switchplates.PNG'
}, {
  title: 'Flower Switchplates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFlower.jpeg'
}, {
  title: 'Folk Art Switch Plates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFolkArt.jpeg'
}, {
  title: 'French, Italian, German & More Destinations.',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFrench.jpeg'
}, {
  title: 'Frogs, Turtles and Such',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFrog.jpeg'
}, {
  title: 'Fruit Switchplates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFruit.jpeg'
}, {
  title: 'Fun and Nostalgia',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FFunandNostalgia.jpeg'
}, {
  title: 'Golf Light Switch Plates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FGolf.jpeg'
}, {
  title: 'Halloween',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FHalloween.jpeg'
}, {
  title: 'Horse Switch Plates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FHorse.jpeg'
}, {
  title: 'Jungle & Safari Animals',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FJungle%26SafariAnimals.jpeg'
}, {
  title: 'Kids Rooms',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FKids.jpeg'
}, {
  title: 'Kitchen Switchplates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FKitchen.jpeg'
}, {
  title: 'Laundry Room and Sewing',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FLaundryRoomandSewing.jpeg'
}, {
  title: 'Leaves and Trees',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FLeavesAndTrees.jpeg'
}, {
  title: 'Lighthouse Switchplates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FLighthouse.jpeg'
}, {
  title: 'Man Cave Switchplates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FManCave.jpeg'
}, {
  title: 'Movie Themes Switchplates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FMovie.jpeg'
}, {
  title: 'Music and Dance',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FMusic.jpeg'
}, {
  title: 'Nautical Switch Plates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FNautical.jpeg'
}, {
  title: 'Patterns',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FPatterns.jpeg'
}, {
  title: 'Quad Switchplates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FQuad%20Switch%20Plates.PNG'
}, {
  title: 'Roosters & Chickens',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FRoosters%26Chickens.jpeg'
}, {
  title: 'Seashell Switch Plates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FSeashell.jpeg'
}, {
  title: 'Sports Switchplates',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FSports.jpeg'
}, {
  title: 'Trains & Planes',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FTrains%26Planes.jpeg'
}, {
  title: 'Travel',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FTravel.jpeg'
}, {
  title: 'Tropical Fish and Sea Life',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FTropicalFish.jpeg'
}, {
  title: 'Cabins, Wildlife and Mountains',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FCabins.jpeg'
}, {
  title: 'Wine & Wine Bottles',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FWine.jpeg'
}, {
  title: 'World Cultures',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=11289&user=6018&w=250&h=200&file=uploaded%2Fimages%2FCategory%20Images%2FWorld.jpeg'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 15
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: 'easeOut'
    }
  }
};
function ProductCard() {
  return <a href="#/product" className="bg-white rounded-sm shadow-warm border border-warmBorder overflow-hidden group flex flex-col h-full hover:shadow-warm-lg transition-shadow duration-300 block" data-id="element-1324">
      <div className="aspect-[3/4] overflow-hidden bg-cream-dark relative p-4 flex items-center justify-center" data-id="element-1325">
        <img src="https://cdn.magicpatterns.com/uploads/kYwoqnKAXP4CNvPbW3sRp7/FG293_List_Image.jpg" alt="Butterfly Switchplate Cover" className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500" loading="lazy" data-id="element-1326" />
      </div>
      <div className="p-4 flex flex-col flex-grow text-center border-t border-warmBorder" data-id="element-1327">
        <h3 className="text-sm font-serif text-charcoal mb-2 flex-grow group-hover:text-gold transition-colors" data-id="element-1328">
          Butterfly Switchplate Cover
        </h3>
        <div className="text-gold font-bold mb-4" data-id="element-1329">$10.95</div>
        <div className="w-full py-2.5 bg-gold group-hover:bg-gold-light text-white text-xs font-bold uppercase tracking-wider rounded-sm transition-colors text-center" data-id="element-1330">
          Select Sizes
        </div>
      </div>
    </a>;
}
export function SwitchplatesPage() {
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
  // Read ?cat= param from hash URL on mount and on hash change
  useEffect(() => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.split('?')[1] || '');
    const catName = params.get('cat');
    if (catName) {
      const found = ALL_CATEGORIES.find(c => c.title === decodeURIComponent(catName));
      if (found) {
        setSelectedCategory(found);
      }
    } else {
      setSelectedCategory(null);
    }
  }, []);
  // Listen for hash changes (e.g. clicking category links from other pages)
  useEffect(() => {
    const onHashChange = () => {
      const hash = window.location.hash;
      if (hash.startsWith('#/switchplates')) {
        const params = new URLSearchParams(hash.split('?')[1] || '');
        const catName = params.get('cat');
        if (catName) {
          const found = ALL_CATEGORIES.find(c => c.title === decodeURIComponent(catName));
          if (found) {
            setSelectedCategory(found);
          }
        } else {
          setSelectedCategory(null);
        }
      }
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [selectedCategory]);
  return <section className="bg-cream min-h-screen pb-20" data-id="element-1331">
      {/* Header Area */}
      <div className="bg-cream-dark border-b border-warmBorder mb-10" data-id="element-1332">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14" data-id="element-1333">
          {selectedCategory ? <>
              <nav className="flex items-center gap-2 text-sm text-warmGray mb-4" data-id="element-1334">
                <button onClick={() => setSelectedCategory(null)} className="hover:text-gold transition-colors" data-id="element-1335">
                  All Categories
                </button>
                <ChevronRight size={14} className="text-warmGray/50" data-id="element-1336" />
                <span className="text-charcoal font-medium" data-id="element-1337">
                  {selectedCategory.title}
                </span>
              </nav>
              <h1 className="text-3xl md:text-4xl font-serif text-charcoal mb-4" data-id="element-1338">
                {selectedCategory.title}
              </h1>
              <p className="text-warmGray leading-relaxed max-w-3xl" data-id="element-1339">
                Browse our beautiful collection of {selectedCategory.title}.
                Each switchplate is handmade in the USA with care and attention
                to detail. Matching hand-painted screws are included with every
                order. Available in a variety of sizes to fit any switch or
                outlet configuration.
              </p>
            </> : <h1 className="text-3xl md:text-4xl font-serif text-charcoal" data-id="element-1340">
              Switchplates
            </h1>}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1341">
        {/* All Categories Grid */}
        {!selectedCategory && <div className="mb-20" data-id="element-1342">
            <motion.div variants={containerVariants} initial="hidden" animate="show" className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-5 md:gap-6" data-id="element-1343">
              {ALL_CATEGORIES.map((category, idx) => <motion.button key={idx} variants={itemVariants} onClick={() => setSelectedCategory(category)} className="group block relative rounded-sm bg-white shadow-warm hover:shadow-warm-lg transition-all duration-300 hover:-translate-y-1 text-left w-full" data-id="element-1344">
                  <div className="aspect-[5/4] overflow-hidden relative rounded-t-sm bg-cream-dark" data-id="element-1345">
                    <img src={category.image} alt={category.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ease-out" loading="lazy" data-id="element-1346" />
                  </div>
                  <div className="p-4 bg-white relative z-20 border-t border-warmBorder rounded-b-sm" data-id="element-1347">
                    <h3 className="text-sm md:text-base font-serif text-charcoal group-hover:text-gold transition-colors leading-snug" data-id="element-1348">
                      {category.title}
                    </h3>
                  </div>
                </motion.button>)}
            </motion.div>
          </div>}

        {/* Products Grid */}
        <div data-id="element-1349">
          {!selectedCategory && <div className="mb-8 border-t border-warmBorder pt-12" data-id="element-1350">
              <h2 className="text-2xl font-serif text-charcoal" data-id="element-1351">
                Featured Products
              </h2>
            </div>}

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 md:gap-6" data-id="element-1352">
            {Array.from({
            length: 10
          }).map((_, idx) => <ProductCard key={idx} data-id="element-1353" />)}
          </div>
        </div>
      </div>
    </section>;
}